import React from 'react';
import '../template-file-css/document-file-template.css';


export const AFHS_ContractorTimeOffNotice = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='AFHS_ContractorTimeOffNotice' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'><h3>TIME OFF NOTIFICATION FORM</h3>
                    <br />
                    “Notification is required for
                    more than 2 days off
                    A 30 day notice is required for time off
                    for 7 days or more.</p>

                <p className='w-750'><h4>CONTRACTOR INFORMATION</h4></p>

                <table>

                    <tr>
                        <td className='w-400'>
                            <span className='eleHeader'>NAME:</span></td>
                        <td className='w-150'>
                            <span className='eleHeader'>TODAY'S DATE: </span></td>
                        <td className='w-200'>
                            <span className='eleHeader'>NUMBER OF DAYS OFF:</span></td>
                    </tr>
                    <tr>
                        <td className='w-400'>
                            <input type='text' id='txtName' name='txtName' className='add-only' /></td>
                        <td className='w-150'>
                            <input type='date' id='txtTodayDate' name='txtTodayDate' className='add-only' /></td>
                        <td className='w-200'>
                            <input type='text' id='txtNumberOfDaysOff' name='txtNumberOfDaysOff' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>STARTING ON:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>ENDING ON:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>I WILL RETURN TO WORK ON:
                            </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='date' id='txtStartingOn' name='txtStartingOn' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='date' id='txtEndingOn' name='txtEndingOn' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='date' id='txtWillReturnToWorkOn' name='txtWillReturnToWorkOn' className='add-only' /></td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>TYPE OF REQUEST</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbTypeOfRequest_1' name='rbTypeOfRequest' className='add-only' value='Vacation' />  VACATION</td>
                        <td className='w-250'>
                            <input type='radio' id='rbTypeOfRequest_2' name='rbTypeOfRequest' className='add-only' value='MilitaryLeave' />  MILITARY LEAVE</td>
                        <td className='w-250'>
                            <input type='radio' id='rbTypeOfRequest_3' name='rbTypeOfRequest' className='add-only' value='PersonalLeave' />  PERSONAL LEAVE</td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbTypeOfRequest_4' name='rbTypeOfRequest' className='add-only' value='FamilyAndMedical' />  FAMILY AND MEDICAL LEAVE</td>
                        <td className='w-250'>
                            <input type='radio' id='rbTypeOfRequest_5' name='rbTypeOfRequest' className='add-only' value='BereavementLeave' />  BEREAVEMENT LEAVE</td>
                        <td className='w-250'>
                            <input type='radio' id='rbTypeOfRequest_6' name='rbTypeOfRequest' className='add-only' value='SickTime' />  SICK TIME</td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbTypeOfRequest_7' name='rbTypeOfRequest' className='add-only' value='JuryDuty' />  JURY DUTY</td>
                        <td className='w-250'>
                            <input type='radio' id='rbTypeOfRequest_8' name='rbTypeOfRequest' className='add-only' value='TimeOffToVote' />  TIME OFF TO VOTE</td>
                        <td className='w-250'>&nbsp;</td>

                    </tr>
                </table>
                <p className='w-750'><span className='eleHeader'>IDENTIFIED COVERAGE</span>
                    <textarea id='txtIdentifiedCoverages' name='txtIdentifiedCoverages' className='add-only'></textarea>
                </p>
                <p className='w-750'><span className='eleHeader'>CONTRACTOR CERTIFICATION</span>
                    I understand that I have to identify another therapist to cover my clients in the event of an
                    emergency. I have identified the therapist listed above. I will be sure to communicate with
                    all parties associated with my clients including management who will cover my cases.
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp;</td>
                        <td className='signature w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Contractor Signature:</td>
                        <td className='small w-375'>Date</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp;</td>
                        <td className='signature w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Management Signature:</td>
                        <td className='small w-375'>Date</td>
                    </tr>
                </table>






            </div>
        </form >

    )
}   